import React from "react";

// The serving indicator. The app tints lib/assets/tennis_ball.png, whose seams
// are transparent gaps rather than drawn lines, so the ball reads as a flat
// disc with two curved cut-outs.
//
// Drawn here instead of loaded: the tint is an arbitrary colour (chartreuse or
// black, see matchServeBallColor), and a CSS filter can only push a PNG to
// black or white.
//
// The mask id is a constant — only one ball is on screen at a time (one team
// serves), and two copies of an identical mask would be harmless anyway.
const SEAM_MASK_ID = "tennisBallSeam";

export default function ServeBall({ size = 24, color = "#C6F135" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      aria-hidden="true"
      focusable="false"
    >
      <mask id={SEAM_MASK_ID}>
        <rect x="0" y="0" width="100" height="100" fill="#000000" />
        <circle cx="50" cy="50" r="50" fill="#FFFFFF" />
        {/* One seam leaves at the left of the equator, the other arrives from
            the right — the two halves of the ball's single seam. */}
        <g fill="none" stroke="#000000" strokeWidth="9">
          <path d="M52 -3 C53 24 48 44 -3 51" />
          <path d="M103 52 C66 56 56 66 54 103" />
        </g>
      </mask>
      <circle
        cx="50"
        cy="50"
        r="50"
        fill={color}
        mask={`url(#${SEAM_MASK_ID})`}
      />
    </svg>
  );
}
